import { recipe } from "@vanilla-extract/recipes";
import { style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";

import { responsiveContainer } from "../../utils/responsive";

import { theme } from "../../theme/css/theme.css";
import { formRowGroupStyle } from "./FormRowGroup.css";

export const FORM_ROW_BREAKPOINT = 500;
export const FORM_ROW_LABEL_BASIS = 50;

export const formRowStyle = recipe({
  base: {
    width: "100%",
    display: "flex",
    selectors: {
      [`${formRowGroupStyle} &`]: {
        width: "inherit",
      },
    },
  },
  variants: {
    variant: {
      auto: {
        flexDirection: "column",
        gap: theme.spacings.xs,
        alignItems: "flex-start",
        justifyContent: "flex-start",
        ...responsiveContainer({
          [FORM_ROW_BREAKPOINT]: {
            flexDirection: "row",
            alignItems: "flex-start",
          },
        }),
      },
      autoSpace: {
        flexDirection: "column",
        gap: theme.spacings.xs,
        alignItems: "flex-start",
        justifyContent: "flex-start",
        ...responsiveContainer({
          [FORM_ROW_BREAKPOINT]: {
            flexDirection: "row",
            alignItems: "flex-start",
            justifyContent: "space-between",
          },
        }),
      },
      vertical: {
        flexDirection: "column",
        gap: theme.spacings.xs,
        alignItems: "flex-start",
        justifyContent: "flex-start",
        flexGrow: 0,
      },
    },
    grow: {
      true: {
        flexGrow: 1,
      },
    },
  },
  defaultVariants: {
    variant: "auto",
  },
});

export const requiredStyle = style({
  color: theme.colors.secondaryHover,
});

export const labelStyle = recipe({
  base: {},
  variants: {
    empty: {
      true: {
        vars: {
          "--min-height": "auto",
        },
      },
      false: {
        ...responsiveContainer({
          [FORM_ROW_BREAKPOINT]: {
            vars: {
              "--min-height": rem(46),
            },
          },
        }),
      },
    },
    variant: {
      auto: {
        minHeight: `var(--min-height, ${rem(28)})`,
        ...responsiveContainer({
          [FORM_ROW_BREAKPOINT]: {
            flexBasis: `var(--label-basis, ${FORM_ROW_LABEL_BASIS}%)`,
          },
        }),
      },
      autoSpace: {
        minHeight: "var(--min-height)",
        ...responsiveContainer({
          [FORM_ROW_BREAKPOINT]: {
            flexBasis: `var(--label-basis, ${FORM_ROW_LABEL_BASIS}%)`,
          },
        }),
      },
      vertical: {
        alignItems: "flex-start",
        minHeight: rem(28),
        paddingTop: rem(4),
      },
    },
  },
  defaultVariants: {
    empty: false,
    variant: "auto",
  },
});

export const inputContainerStyle = recipe({
  base: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    minHeight: rem(46),
    minWidth: 0,
    gap: theme.spacings.xs,
  },
  variants: {
    variant: {
      auto: {
        width: "100%",
        flexGrow: 1,
        flexBasis: `var(--label-basis, ${FORM_ROW_LABEL_BASIS}%)`,
      },
      autoSpace: {
        ...responsiveContainer({
          [FORM_ROW_BREAKPOINT]: {
            alignItems: "flex-end",
          },
        }),
      },
      vertical: {
        width: "100%",
      },
    },
    hasDescriptionAuto: {
      true: {
        ...responsiveContainer({
          [FORM_ROW_BREAKPOINT]: {
            paddingTop: theme.spacings.s,
          },
        }),
      },
    },
  },
  defaultVariants: {
    variant: "auto",
  },
});

export const helpIconStyle = style({
  marginLeft: rem(4),
});
